const publishQueryKeys = {
  resourcePublishDetails: (resourceId) => [
    "resource-publish-details",
    resourceId || null
  ]
};

export { publishQueryKeys };
//# sourceMappingURL=publishQueryKeys.js.map
